/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  KillswitchCapabilityKey,
  KillswitchCapabilityKey$outboundSchema,
} from "../components/killswitchcapabilitykey.js";
import {
  KillswitchListResult,
  KillswitchListResult$inboundSchema,
} from "../components/killswitchlistresult.js";
import {
  KillswitchListStatus,
  KillswitchListStatus$outboundSchema,
} from "../components/killswitchliststatus.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type KillswitchesListSecurity = {
  sessionHeaderGramSession: string;
};

export type KillswitchesListRequest = {
  capabilityKey?: KillswitchCapabilityKey | undefined;
  userId?: string | undefined;
  status?: KillswitchListStatus | undefined;
  limit?: number | undefined;
  cursor?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

export type KillswitchesListResponse = {
  result: KillswitchListResult;
};

/** @internal */
export type KillswitchesListSecurity$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const KillswitchesListSecurity$outboundSchema: z.ZodMiniType<
  KillswitchesListSecurity$Outbound,
  KillswitchesListSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function killswitchesListSecurityToJSON(
  killswitchesListSecurity: KillswitchesListSecurity,
): string {
  return JSON.stringify(
    KillswitchesListSecurity$outboundSchema.parse(killswitchesListSecurity),
  );
}

/** @internal */
export type KillswitchesListRequest$Outbound = {
  capability_key?: string | undefined;
  user_id?: string | undefined;
  status?: string | undefined;
  limit?: number | undefined;
  cursor?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const KillswitchesListRequest$outboundSchema: z.ZodMiniType<
  KillswitchesListRequest$Outbound,
  KillswitchesListRequest
> = z.pipe(
  z.object({
    capabilityKey: z.optional(KillswitchCapabilityKey$outboundSchema),
    userId: z.optional(z.string()),
    status: z.optional(KillswitchListStatus$outboundSchema),
    limit: z.optional(z.int()),
    cursor: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      capabilityKey: "capability_key",
      userId: "user_id",
      gramSession: "Gram-Session",
    });
  }),
);

export function killswitchesListRequestToJSON(
  killswitchesListRequest: KillswitchesListRequest,
): string {
  return JSON.stringify(
    KillswitchesListRequest$outboundSchema.parse(killswitchesListRequest),
  );
}

/** @internal */
export const KillswitchesListResponse$inboundSchema: z.ZodMiniType<
  KillswitchesListResponse,
  unknown
> = z.pipe(
  z.object({
    Result: KillswitchListResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function killswitchesListResponseFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchesListResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KillswitchesListResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchesListResponse' from JSON`,
  );
}
